<!--
  @Description 问题汇总菜单更改历史
  @Date 2022-09-28
  @Author liufu
-->
<template>
  <el-drawer title="设计变更记录" :size="dataIsSingleCol ? '30%' : '50%'" :visible.sync="showDrawer">
    <div
      class="questionHistoryContainer"
      :style="{
        height: height
      }"
    >
      <!-- 无数据 -->
      <div class="null-data" v-if="questionHistoryList.length === 0">
        <img src="../../../assets/img/null-data.png" />
        <div class="null-data__text">暂无数据</div>
      </div>
      <!-- 单列 -->
      <el-timeline v-else-if="dataIsSingleCol">
        <el-timeline-item
          v-for="(item, index) of questionHistoryList"
          :key="index"
          placement="top"
          color="#409EFF"
          size="large"
        >
          <div class="oneLineHeaderContainer">
            <!-- 头部操作区域 -->
            <div class="itemTitle" :style="!item.isShow && 'opacity: 0.5'">
              <div>
                <span :style="getPositionColor(item.type)">{{ item.type }}</span>
                <span>
                  【<span class="questionNum" @click="handleJumpQuestion(item)">{{ item.designOrigin }}</span
                  >】
                </span>
                <span class="grey">{{ handleDateTime(item.recordTime, 'yyyy-MM-dd') }}</span>
              </div>
              <div
                class="foldIcon"
                @click="
                  () => {
                    item.isShow = !item.isShow
                  }
                "
                :style="item.isShow ? '' : 'transform: rotate(180deg);'"
              >
                <i style="line-height: 19px;" class="el-icon-arrow-up"></i>
              </div>
            </div>
            <!-- 内容区域 -->
            <el-card v-show="item.isShow">
              <div class="itemContent">
                <span class="cardLableSpan">需求点: </span><br />
                <div class="content">{{ item.content }}</div>
                <br /><br />
                <span class="cardLableSpan">变更内容: </span><br />
                <div class="content">{{ item.designComment }}</div>
              </div>
            </el-card>
          </div>
        </el-timeline-item>
      </el-timeline>
      <!-- 多列 -->
      <div class="doubleLine" v-else>
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) of questionHistoryList"
            :key="index"
            placement="top"
            color="#409EFF"
            size="large"
          >
            <div class="questionTimeLineItem">
              <div class="timelineLeft">
                <!-- 前端左右分开 -->
                <div v-if="item.type === '前端'">
                  <!-- 头部操作区域 -->
                  <div class="itemTitle" :style="!item.isShow && 'opacity: 0.5'">
                    <div
                      class="foldIcon"
                      @click="
                        () => {
                          item.isShow = !item.isShow
                        }
                      "
                      :style="item.isShow ? '' : 'transform: rotate(180deg);'"
                    >
                      <i style="line-height: 19px;" class="el-icon-arrow-up"></i>
                    </div>
                    <div>
                      <span class="grey">{{ handleDateTime(item.recordTime, 'yyyy-MM-dd') }}</span>
                      <span>
                        【<span class="questionNum" @click="handleJumpQuestion(item)">{{ item.designOrigin }}</span
                        >】
                      </span>
                      <span :style="getPositionColor(item.type)">{{ item.type }}</span>
                    </div>
                  </div>
                  <!-- 操作区域 -->
                  <el-card v-show="item.isShow">
                    <div class="itemContent">
                      <span class="cardLableSpan">需求点: </span><br />
                      <div class="content">{{ item.content }}</div>
                      <br /><br />
                      <span class="cardLableSpan">变更内容: </span><br />
                      <div class="content">{{ item.designComment }}</div>
                    </div>
                  </el-card>
                </div>
              </div>
              <div class="timelineRight">
                <div v-if="['后端', '数据库'].includes(item.type)">
                  <!-- 头部操作区域 -->
                  <div class="itemTitle" :style="!item.isShow && 'opacity: 0.5'">
                    <div>
                      <span :style="getPositionColor(item.type)">{{ item.type }}</span>
                      <span>
                        【<span class="questionNum" @click="handleJumpQuestion(item)">{{ item.designOrigin }}</span
                        >】
                      </span>
                      <span class="grey">{{ handleDateTime(item.recordTime, 'yyyy-MM-dd') }}</span>
                    </div>
                    <div
                      class="foldIcon"
                      @click="
                        () => {
                          item.isShow = !item.isShow
                        }
                      "
                      :style="item.isShow ? '' : 'transform: rotate(180deg);'"
                    >
                      <i style="line-height: 19px;" class="el-icon-arrow-up"></i>
                    </div>
                  </div>
                  <!-- 操作区域 -->
                  <el-card v-show="item.isShow">
                    <div class="itemContent">
                      <span class="cardLableSpan">需求点: </span><br />
                      <div class="content">{{ item.content }}</div>
                      <br /><br />
                      <span class="cardLableSpan">变更内容: </span><br />
                      <div class="content">{{ item.designComment }}</div>
                    </div>
                  </el-card>
                </div>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <!-- 历史问题号查看问题 -->
    <HistoryQuestionShow ref="HistoryQuestionShow" />
  </el-drawer>
</template>

<script>
import HistoryQuestionShow from './HistoryQuestionShow.vue'
export default {
  name: 'QuestionUpdateHistory',
  components: {
    HistoryQuestionShow
  },
  props: {
    height: {
      type: String,
      default: 'calc(100vh-77px)'
    }
  },
  data() {
    return {
      // 是否展示抽屉
      showDrawer: false,
      // 抽屉明细数据
      questionHistoryList: [],
      // 是否只有单边
      dataIsSingleCol: false
    }
  },
  methods: {
    // 获取某个问题号的明细内容
    async handleGetQuestionDetail(id) {
      const { data: res } = await this.$http.get('/Common/YKCase/both', {
        params: {
          id
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return res.data
    },
    // 跳转问题
    async handleJumpQuestion(item) {
      const questionForm = await this.handleGetQuestionDetail(item.ykCaseID)
      // 如果不为false的情况下展示窗口
      if (questionForm) {
        this.$refs.HistoryQuestionShow.form = questionForm
        this.$refs.HistoryQuestionShow.isShow = true
      }
    },
    // 获取名字颜色
    getPositionColor(positon) {
      switch (positon) {
        case '前端':
          return { color: '#409eff' }
        case '后端':
          return { color: '#dc7404' }
        case '数据库':
          return { color: '#1a1aa8' }
      }
    },
    // 处理日期
    handleDateTime(value, fmt = 'yyyy-MM-dd HH:mm:ss') {
      const res = this.ykDateFormat(fmt, value)
      if (!res) {
        return ''
      }
      return res
    }
  }
}
</script>

<style lang="less" scoped>
.questionHistoryContainer {
  width: 100%;
  overflow: auto;
  box-sizing: border-box;
  padding: 0 20px;
}

/** ************* 滚动条整体样式 ************** **/
.questionHistoryContainer::-webkit-scrollbar {
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  // height: auto;
  // display: none;
}

/*滚动条里面小方块*/
.questionHistoryContainer::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}

/*滚动条里面轨道*/
.questionHistoryContainer::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: #ededed;
  border-radius: 20px;
}

.questionTimeLineItem {
  // margin-left: -100%;
  // padding-left: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  .timelineLeft {
    width: calc(50% - 28px);
    // .itemTitle {
    //   display: flex;
    //   justify-content: flex-end;
    // }
  }
  .timelineRight {
    width: calc(50% - 28px);
  }
}

.itemContent {
  width: 100%;
  word-break: break-all;
  font-size: 14px;
  // margin-top: 5px;
  color: #555555;
}

.null-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .null-data__text {
    width: 100%;
    display: flex;
    justify-content: center;
    color: #aeaeae;
  }
  > img {
    width: 200px;
    height: 200px;
  }
}

.bold {
  font-weight: bold;
}

.itemTitle {
  margin-bottom: 5px;
  transition: all 0.5s;
  // cursor: pointer;
  > span {
    font-size: 14px !important;
    margin-right: 5px;
  }
  .questionNum {
    color: #48a2ff;
    cursor: pointer;
  }
  .questionNum:hover {
    color: #409eff;
    text-decoration: underline;
  }
}
.black {
  color: #333;
  font-weight: bold;
}

.grey {
  color: #999999;
}
.doubleLine {
  /deep/ .el-timeline-item__node--large {
    margin-left: calc(50% - 5px);
  }
  /deep/ .el-timeline-item__tail {
    margin-left: calc(50% - 5px);
  }
  /deep/ .el-timeline-item__wrapper {
    padding: 0;
  }
  .el-timeline {
    padding: 0;
  }
}
.cardLableSpan {
  font-weight: bold;
  font-size: 15px;
  text-shadow: 1px 1px #d6d2d2;
}
.foldIcon {
  display: flex;
  justify-content: flex-end;
  transition: all 0.5s;
  cursor: pointer;
}
.oneLineHeaderContainer,
.timelineLeft,
.timelineRight {
  .itemTitle {
    display: flex;
    justify-content: space-between;
  }
}
.content {
  white-space: pre-wrap;
  word-wrap: break-word;
  box-sizing: border-box;
  padding-left: 10px;
}
</style>
